@if (item && itemType) { @if (item.deleted) {
<div class="watchlist-item">
  <div class="watchlist-item__image">
    <bau365-watchlist-image class="not-found__image" [category]="itemType"></bau365-watchlist-image>
  </div>
  <div class="watchlist-item__information information">
    <div class="information__name element-not-found" i18n="@@featureWatchlist-elementNotFound">
      Inhalt wurde gelöscht
    </div>
  </div>
  <div class="watchlist-item__actions">
    <button class="action action--remove" (click)="deleteWatchlistItem(item)">
      <mat-icon class="icon-trash">delete</mat-icon>
    </button>
  </div>
</div>
} @else { @if (item.data) {
<div class="watchlist-item">
  <a
    class="watchlist-item__link"
    [routerLink]="[
      '/fairs',
      item.fair_id,
      itemType.slug,
      itemType.type === 'BRAND' ? item.data.exhibitorId : item.entity_id
    ]"
    [queryParams]="itemType.type === 'BRAND' ? { brand: true } : {}">
    @if (screen === 'phone') {
    <span class="fair-chip">{{ fair?.name }}</span>
    }
    <div class="watchlist-item__image" [ngClass]="{ 'watchlist-item__image-and-location': screen === 'phone' }">
      <bau365-watchlist-image
        [alt]="item.data.name"
        [image]="itemType.type === 'BRAND' ? item.data.brand?.logo : item.data.image"
        [category]="itemType"></bau365-watchlist-image>
      @if (screen === 'phone' && (hallPlanToggle$ | async) && fair?.hallplan) {
      <planone-location
        class="exhibition-halls"
        [exhibition_halls]="item.data.exhibitionHalls"
        [fair_id]="item.fair_id"></planone-location>
      }
    </div>
    <div class="watchlist-item__information information">
      @if (itemType.type === 'BRAND') {
      <div class="information__name">{{ item.data.brand?.name }}</div>
      } @else {
      <div class="information__name">{{ item.data.name }}</div>
      }
      <div class="information__details details">
        <div class="details__category" [ngClass]="{ 'details__category--only': !item.data.exhibitorName }">
          {{ itemType.type === EntityType.exhibitor && item.fair_id === '229' ? companyLabel : itemType.label }}
        </div>
        @if (itemType.slug === 'products' || itemType.type === 'BRAND') {
        <div class="details__exhibitor">
          <mat-icon>corporate_fare</mat-icon>
          {{ item.data.exhibitorName }}
        </div>
        } @if (itemType.slug === 'events') {
        <div class="details__event">
          <mat-icon>schedule</mat-icon>
          {{ { start: item.data.starts_at, end: item.data.ends_at } | datetimeRange }}
        </div>
        }
      </div>
    </div>
    @if (screen !== 'phone') {
    <div class="watchlist-item__fair">
      <span class="fair-chip">{{ fair?.name }}</span>
    </div>
    } @if ((hallPlanToggle$ | async) && screen !== 'phone') {
    <div class="watchlist-item__exhibition-halls exhibition-halls">
      @if (item.data.exhibitionHalls && fair?.hallplan) {
      <planone-location [exhibition_halls]="item.data.exhibitionHalls" [fair_id]="item.fair_id"></planone-location>
      }
    </div>
    }
  </a>
  <div class="watchlist-item__actions">
    <button class="action action--share" (click)="openShareDialog($event)">
      <mat-icon class="icon-share action__icon">share</mat-icon>
    </button>
    <button class="action action--remove" (click)="deleteWatchlistItem(item)">
      <mat-icon class="icon-trash action__icon">delete</mat-icon>
    </button>
  </div>
</div>
} } }
<ng-template #shareButtonsTitle>
  <span i18n="@@featureWatchlist-shareDialog-title">Teilen</span>
</ng-template>
<ng-template #shareButtons>
  <planone-share-buttons
    [url]="url"
    [disabledProvider]="['print']"
    (shareButtonClicked)="shareButtonClick($event)"></planone-share-buttons>
</ng-template>
